<script lang="ts">
    import { spaLink } from "../../../functionTools/navigation"
    import { overlay } from "../../../store"
    import CartItems from "./CartItems.svelte"
    import { login } from "../../../functionTools/login"
    import { cart } from "../../../functionTools/cart"
    import { _ } from "svelte-i18n"
    import { initialLocale } from "../../../i18n"
    import CartSum from "./CartSum.svelte"

    interface Props {
        checkoutButton?: boolean
        invalidProductsInCart?: boolean
    }

    let { checkoutButton = true, invalidProductsInCart = $bindable(false) }: Props = $props()

    let innerWidth: number = $state()
    $effect(() => {
        invalidProductsInCart = $login && !!$cart?.filter((c) => c.product.no_dealers).length
    })

    let normalCart = $derived($login ? $cart.filter((i) => !i.product.price_net_dealer_is_fixed) : $cart.slice())
    let fixedPriceCart = $derived($login ? $cart.filter((i) => i.product.price_net_dealer_is_fixed) : [])
</script>

<svelte:window bind:innerWidth />

<div class="cart">
    {#if $cart?.length}
        {#if $login}
            <h3>{$_("cart.products-with-individual-conditions")}</h3>
            <section>
                <div class="dealerInfo">
                    {$_("cart.dealer-conditions-info")}
                    <br />
                    <br />
                </div>
            </section>
        {/if}

        <CartItems cartItems={normalCart} />
        <CartSum cartItems={normalCart} />
        {#if $login}
            <br />
            <br />
            <h3>{@html $_("cart.products-with-fixed-prices")}</h3>
            <CartItems cartItems={fixedPriceCart} />
            <CartSum cartItems={fixedPriceCart} />
            <br />
        {/if}
        {#if invalidProductsInCart}
            <div style="color: darkred;">
                <br />
                {@html $_("cart.invalid-products")}
            </div>
        {:else if checkoutButton}
            <div style="display: flex; justify-content: space-between">
                <div>
                    <!-- svelte-ignore a11y_invalid_attribute -->
                    <a
                        href="#"
                        class="button secondary"
                        onclick={(e) => {
                            e.preventDefault()
                            $overlay.show = false
                        }}
                    >
                        {$_("cart.continue_shopping")}
                    </a>
                </div>
                <div>
                    <a
                        href="/checkout{$login ? '/dealer' : ''}"
                        class="button primary"
                        data-testid="cart-checkout-link"
                        use:spaLink
                        onclick={() => {
                            $overlay.show = false
                        }}
                    >
                        {$_("cart.checkout now")}
                    </a>
                </div>
            </div>
        {/if}
    {:else}
        <div class="empty_cart">
            {$_("cart.cart-is-empty")}<br />
            <a
                href="/{initialLocale}"
                use:spaLink
                onclick={(e) => {
                    e.stopPropagation()
                    $overlay.show = false
                }}>{$_("cart.shopping-now")}</a
            >
        </div>
        <!-- svelte-ignore a11y_invalid_attribute -->
        <a
            href="/{initialLocale}"
            use:spaLink
            class="button secondary"
            onclick={(e) => {
                e.stopPropagation()
                $overlay.show = false
            }}
        >
            {$_("cart.continue_shopping")}
        </a>
    {/if}
</div>

<style lang="less">
    @import "../../../css/variables.less";
    a.button {
        padding: 5px 10px;
    }
    .empty_cart {
        .flex();
        align-items: center;
        justify-content: center;
        height: 400px;
        flex-direction: column;
    }
    .cart :global {
        .variant {
            font-size: 0.8em;
        }
    }
</style>
